import { render, staticRenderFns } from "./AppToAlipay.vue?vue&type=template&id=552b4116&scoped=true&"
import script from "./AppToAlipay.vue?vue&type=script&lang=ts&"
export * from "./AppToAlipay.vue?vue&type=script&lang=ts&"
import style0 from "./AppToAlipay.vue?vue&type=style&index=0&id=552b4116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552b4116",
  null
  
)

export default component.exports